import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const NAV_SECTION_KEY = 'iez-nav-section';

const clearClientCache = () => {
  const preservedNavSection = sessionStorage.getItem(NAV_SECTION_KEY);
  localStorage.clear();
  sessionStorage.clear();
  if (preservedNavSection) sessionStorage.setItem(NAV_SECTION_KEY, preservedNavSection);

  if ('caches' in window) {
    caches.keys().then(keys => {
      keys.forEach(key => caches.delete(key));
    });
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => {
      regs.forEach(reg => reg.unregister());
    });
  }

  console.log('Client cache cleared on route change');
};

const CacheClearOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    clearClientCache();
  }, [location.pathname]);

  return null;
};

export default CacheClearOnRouteChange;